<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getAccountChatList()"
          variant="primary"
          size="sm"
        )
      .form-group.col-12(v-if="isEditAccess && accountChatList.length < cpList.length")
        b-button(type="button" variant="info" size="sm" @click="onAddLivechat" @clicked="afterUpdateLivechat")
          i.fa.fa-lg.fa-plus
          span.ml-1 {{ $t("ui.combine.add_livechat") }}
      .form-group.col-12.mb-1(v-if="cpList.length > 1")
        .alert.alert-warning.p-1 {{ $t("message.tooltips_allow_one_active_livechat") }}
  .card-body
    .row
      .col-md-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th(width="15%")
                  span(:title="$t('ui.chat_id')") {{ $t('ui.chat_id') }}
                th(width="14%")
                  span(:title="$t('ui.chat_provider')") {{ $t("ui.chat_provider") }}
                th.text-center(width="10%")
                  span(:title="$t('ui.image')") {{ $t("ui.image") }}
                th(width="10%")
                  template(v-if="cpList.includes('ZENO')")
                    span(:title="$t('ui.property_id') + ' / ' + $t('ui.property_id')") {{ $t("ui.property_id") }} / {{ $t("ui.platform") }}
                  template(v-else)
                    span(:title="$t('ui.property_id')") {{ $t("ui.property_id") }}
                th(width="10%")
                  span(:title="$t('ui.widget_id')") {{ $t("ui.widget_id") }}
                th.text-center(width="6%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-right(width="12%")
                  span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                th.text-right(width="12%")
                  span(:title="$t('ui.modified_date')") {{ $t('ui.modified_date') }}
                th.text-center(width="6%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
            tbody.clusterize-content
              tr(v-if="accountChatList.length == 0")
                td(colspan="10").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in accountChatList")
                td.text-center
                  span(:title="index + 1") {{ index + 1 }}
                td
                  span(:title="item.chat_id") {{ item.chat_id }}
                td
                  span(:title="item.chat_provider") {{ item.chat_provider }}
                td
                  span(v-if="item.image_id")
                    b-img.fiximg(:src="imagePath + item.image_id" @error="handleImageError")
                td
                  span(:title="item.credential_1") {{ item.credential_1 }}
                td
                  span(:title="item.credential_2") {{ item.credential_2 }}
                td
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changeAccountChatStatus(item, $event)" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.text-right
                  span(:title="item.created_by") {{ item.created_by }}
                  br
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span(:title="item.modified_by") {{ item.modified_by ? item.modified_by : "-" }}
                  br
                  span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ item.modified_date ? $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') : "-" }}
                td.actions.text-center(v-if="isEditAccess")
                  span
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onUpdateLivechat(item)" :title="$t('ui.edit')")

    updatelivechat(ref="updatelivechat" :item="editSelectedLivechat" :cpList="cpList" :existChatProvider="existChatProvider" @clicked="afterUpdateLivechat" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import updatelivechat from "@/components/cms/updateLivechat.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    updatelivechat,
  },
  data: () => ({
    loading: false,
    accountChatList: [],
    search: "",
    chat_provider: "LiveChatInc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedLivechat: null,
    imagePath: config.viewImageUrl,
    existChatProvider: null,
    cpList: ['LIVECHATINC'],
    showTable: false
  }),
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_cms");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {},
  methods: {
    refresh() {
      this.cpList = ['LIVECHATINC']

      var chatProvider = config.chatProvider
      if(chatProvider != null) {
        var splitCp = chatProvider.split(',')
        for(var i = 0; i < splitCp.length; i++) {
          this.cpList.push(splitCp[i])
        }
      }

      this.getAccountChatList()
    },
    handleImageError(event) {
      event.target.src = 'https://placehold.co/150?text=No+Image'; // Set fallback image
    },
    addLivechat: function() {
      this.getAccountChatList();

      this.$helpers.showDialog(this.$t("ui.combine.add_livechat"), this.$t("message.success"), "success");
    },
    onAddLivechat() {
      this.existChatProvider = null
      this.editSelectedLivechat = null
      if(this.accountChatList.length > 0) {
        this.existChatProvider = []
        for(var i = 0; i < this.accountChatList.length; i++) {
          this.existChatProvider.push(this.accountChatList[i].chat_provider);
        }
        // this.existChatProvider = this.accountChatList[0].chat_provider;
      }
      this.$refs.updatelivechat.$refs.updateLivechat.show();
    },
    onUpdateLivechat(e) {
      this.editSelectedLivechat = e;
      this.$refs.updatelivechat.$refs.updateLivechat.show();
    },
    afterUpdateLivechat: function(addUpdateTxt) {
      this.$helpers.showDialog(this.$t("ui.combine." + addUpdateTxt + "_livechat"), this.$t("message.success"), "success");

      this.getAccountChatList();
    },
    getAccountChatList: function() {
      let url = config.accountChatListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.accountChatList = response.data.dt;
                this.editSelectedLivechat = null
                this.existChatProvider = null
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changeAccountChatStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_account_chat_status_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmAccountChatStatus(eventStatus.srcElement.checked, item.chat_provider);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmAccountChatStatus: function(status, chatProvider) {
      let url = config.accountChatStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        chat_provider: chatProvider,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getAccountChatList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getAccountChatList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>